import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "paymentOptionHeader" }
const _hoisted_2 = {
  key: 0,
  class: "rateType"
}
const _hoisted_3 = { class: "ratePercent" }
const _hoisted_4 = {
  key: 1,
  class: "monthlyPaymentAmount"
}

import {
  reactive,
  ref,
  computed,
  watch,
  onMounted,
} from "vue";
import BaseFormFieldRadio from "@/components/v2/shared/BaseFormFieldRefiRadio.vue";
import { FieldSchema } from "@/models/form";
import { useStore } from "vuex";

interface Props {
  rateType: string;
  option: any;
  singleRateTypeAvailable?: boolean;
  singleRateOptionClicked?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RefiProgramLoanOptionDetails',
  props: {
    rateType: {},
    option: {},
    singleRateTypeAvailable: { type: Boolean, default: false },
    singleRateOptionClicked: { type: Boolean, default: false }
  },
  emits: ["radioButtonClicked"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

const props = __props;

const emit = __emit;

const ratePlanOption = ref<any | undefined>(undefined);

const selectedRatePlanId = computed(
  () => store.state.refiLoanConfigurationModule.selectedRatePlanId,
);
const selectedRateOption = computed(
  () => store.state.refiLoanConfigurationModule.selectedRateOption,
);

const isSelected = computed(() => ratePlanOption.value?.rateId === selectedRatePlanId.value);
const styleOption = computed(() => store.getters["refiLoanConfigurationModule/StyleOption"]);

function handleRadioButtonClick(event: any) {
  if (event) {
    store.dispatch("refiLoanConfigurationModule/setSelectedRatePlanId", event?.rateId);
    store.dispatch("refiLoanConfigurationModule/setSelectedRateOption", event);
    emit("radioButtonClicked", event);
  }
}
onMounted(() => {
  if (props.option && props.option.isSelected) {
    handleRadioButtonClick(props.option);
    ratePlanOption.value = props.option;
  }
});
const schema = reactive({
  paymentOption: {
    name: "paymentOption",
    type: "radio",
    required: false,
    hideLabel: true,
  } as FieldSchema,
});

watch(
  () => props.singleRateOptionClicked,
  (currentValue: boolean) => {
    if (currentValue) {
      ratePlanOption.value = undefined;

      handleRadioButtonClick(props.option);
      ratePlanOption.value = selectedRateOption.value;
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["paymentOption", { single: __props.singleRateTypeAvailable, active: isSelected.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!__props.singleRateTypeAvailable || (__props.singleRateTypeAvailable && styleOption.value === 1))
        ? (_openBlock(), _createBlock(BaseFormFieldRadio, {
            key: 0,
            schema: schema.paymentOption,
            options: [{ label: __props.rateType, value: __props.option }],
            modelValue: ratePlanOption.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((ratePlanOption).value = $event)),
              handleRadioButtonClick
            ],
            class: _normalizeClass({ active: isSelected.value })
          }, null, 8, ["schema", "options", "modelValue", "class"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["paymentOptionDetails", `styleOption${styleOption.value}`])
    }, [
      (__props.singleRateTypeAvailable && styleOption.value === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.rateType), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.option.rateDisplay), 1),
      (__props.option?.estimatedPayment)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("p", null, _toDisplayString(__props.option?.estimatedPayment), 1),
            _cache[1] || (_cache[1] = _createElementVNode("span", null, "Per Month", -1))
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})